// Badge definitions and computation for HamExpert
// All badges are computed client-side from stats + qsos

var BADGE_DEFS = [
  // QSO Milestones
  { id: "qso100", icon: "\u{1F4E1}", cat: "qso", levels: [100, 500, 1000, 5000, 10000, 25000, 50000], field: "total" },
  // DX Hunter
  { id: "dxcc", icon: "\u{1F30D}", cat: "dx", levels: [25, 50, 100, 150, 200, 250, 300], field: "uniqueCountries" },
  // Grid Master
  { id: "grids", icon: "\u{1F4CD}", cat: "grid", levels: [50, 100, 500, 1000, 1500], field: "uniqueGrids" },
  // Unique Calls
  { id: "calls", icon: "\u{1F465}", cat: "social", levels: [100, 500, 1000, 5000, 10000], field: "uniqueCalls" },
];

var TIER_NAMES = ["bronze", "silver", "gold", "platinum", "diamond", "master", "legend"];
var TIER_COLORS = ["#cd7f32", "#c0c0c0", "#ffd700", "#00d4ff", "#e879f9", "#ff6b35", "#ef4444"];

export function computeBadges(stats, qsos) {
  if (!stats || !qsos) return [];
  var result = [];

  // Tiered badges (QSOs, DXCC, Grids, Calls)
  for (var i = 0; i < BADGE_DEFS.length; i++) {
    var def = BADGE_DEFS[i];
    var val = stats[def.field] || 0;
    var tier = -1;
    for (var li = def.levels.length - 1; li >= 0; li--) {
      if (val >= def.levels[li]) { tier = li; break; }
    }
    var nextLevel = tier < def.levels.length - 1 ? def.levels[tier + 1] : null;
    var progress = nextLevel ? Math.min(1, val / nextLevel) : 1;
    result.push({
      id: def.id, icon: def.icon, cat: def.cat,
      tier: tier, tierName: tier >= 0 ? TIER_NAMES[Math.min(tier, TIER_NAMES.length - 1)] : null,
      tierColor: tier >= 0 ? TIER_COLORS[Math.min(tier, TIER_COLORS.length - 1)] : "#334155",
      value: val, threshold: tier >= 0 ? def.levels[tier] : def.levels[0],
      nextLevel: nextLevel, progress: progress, unlocked: tier >= 0
    });
  }

  // All Continents (WAC)
  var conts = {};
  for (var ci = 0; ci < qsos.length; ci++) {
    var c = qsos[ci].continent;
    if (c && c !== "??" && c !== "AN") conts[c] = 1;
  }
  var contCount = Object.keys(conts).length;
  result.push({
    id: "wac", icon: "\u{1F310}", cat: "award",
    tier: contCount >= 6 ? 0 : -1, tierName: contCount >= 6 ? "gold" : null,
    tierColor: contCount >= 6 ? "#ffd700" : "#334155",
    value: contCount, threshold: 6, nextLevel: 6, progress: Math.min(1, contCount / 6), unlocked: contCount >= 6
  });

  // Band Explorer
  var bandCount = stats.byBand ? stats.byBand.length : 0;
  var bandLevels = [3, 5, 8, 10, 12];
  var bandTier = -1;
  for (var bi = bandLevels.length - 1; bi >= 0; bi--) { if (bandCount >= bandLevels[bi]) { bandTier = bi; break; } }
  result.push({
    id: "bands", icon: "\u{1F4FB}", cat: "explore",
    tier: bandTier, tierName: bandTier >= 0 ? TIER_NAMES[Math.min(bandTier, TIER_NAMES.length - 1)] : null,
    tierColor: bandTier >= 0 ? TIER_COLORS[Math.min(bandTier, TIER_COLORS.length - 1)] : "#334155",
    value: bandCount, threshold: bandTier >= 0 ? bandLevels[bandTier] : bandLevels[0],
    nextLevel: bandTier < bandLevels.length - 1 ? bandLevels[bandTier + 1] : null,
    progress: bandTier < bandLevels.length - 1 ? Math.min(1, bandCount / bandLevels[bandTier + 1]) : 1, unlocked: bandTier >= 0
  });

  // Mode Master
  var modeCount = stats.byMode ? stats.byMode.length : 0;
  var modeLevels = [2, 3, 5, 7];
  var modeTier = -1;
  for (var mi = modeLevels.length - 1; mi >= 0; mi--) { if (modeCount >= modeLevels[mi]) { modeTier = mi; break; } }
  result.push({
    id: "modes", icon: "\u{1F50A}", cat: "explore",
    tier: modeTier, tierName: modeTier >= 0 ? TIER_NAMES[Math.min(modeTier, TIER_NAMES.length - 1)] : null,
    tierColor: modeTier >= 0 ? TIER_COLORS[Math.min(modeTier, TIER_COLORS.length - 1)] : "#334155",
    value: modeCount, threshold: modeTier >= 0 ? modeLevels[modeTier] : modeLevels[0],
    nextLevel: modeTier < modeLevels.length - 1 ? modeLevels[modeTier + 1] : null,
    progress: modeTier < modeLevels.length - 1 ? Math.min(1, modeCount / modeLevels[modeTier + 1]) : 1, unlocked: modeTier >= 0
  });

  // Digital Pioneer (FT8 + FT4)
  var digitalQsos = 0;
  for (var di = 0; di < qsos.length; di++) { var dm = qsos[di].mode; if (dm === "FT8" || dm === "FT4") digitalQsos++; }
  var digLevels = [100, 500, 1000, 5000, 10000];
  var digTier = -1;
  for (var dli = digLevels.length - 1; dli >= 0; dli--) { if (digitalQsos >= digLevels[dli]) { digTier = dli; break; } }
  result.push({
    id: "digital", icon: "\u{1F4BB}", cat: "mode",
    tier: digTier, tierName: digTier >= 0 ? TIER_NAMES[Math.min(digTier, TIER_NAMES.length - 1)] : null,
    tierColor: digTier >= 0 ? TIER_COLORS[Math.min(digTier, TIER_COLORS.length - 1)] : "#334155",
    value: digitalQsos, threshold: digTier >= 0 ? digLevels[digTier] : digLevels[0],
    nextLevel: digTier < digLevels.length - 1 ? digLevels[digTier + 1] : null,
    progress: digTier < digLevels.length - 1 ? Math.min(1, digitalQsos / digLevels[digTier + 1]) : 1, unlocked: digTier >= 0
  });

  // CW Warrior
  var cwQsos = 0;
  for (var cwi = 0; cwi < qsos.length; cwi++) { if (qsos[cwi].mode === "CW") cwQsos++; }
  var cwLevels = [50, 200, 500, 1000, 5000];
  var cwTier = -1;
  for (var cli = cwLevels.length - 1; cli >= 0; cli--) { if (cwQsos >= cwLevels[cli]) { cwTier = cli; break; } }
  result.push({
    id: "cw", icon: "\u{1F511}", cat: "mode",
    tier: cwTier, tierName: cwTier >= 0 ? TIER_NAMES[Math.min(cwTier, TIER_NAMES.length - 1)] : null,
    tierColor: cwTier >= 0 ? TIER_COLORS[Math.min(cwTier, TIER_COLORS.length - 1)] : "#334155",
    value: cwQsos, threshold: cwTier >= 0 ? cwLevels[cwTier] : cwLevels[0],
    nextLevel: cwTier < cwLevels.length - 1 ? cwLevels[cwTier + 1] : null,
    progress: cwTier < cwLevels.length - 1 ? Math.min(1, cwQsos / cwLevels[cwTier + 1]) : 1, unlocked: cwTier >= 0
  });

  // LoTW Confirmed QSOs (comment === "LoTW")
  var lotwQsos = 0;
  for (var lwi = 0; lwi < qsos.length; lwi++) { if (qsos[lwi].lotwQsl || qsos[lwi].comment === "LoTW") lotwQsos++; }
  var lotwLevels = [10, 100, 500, 1000, 5000, 10000];
  var lotwTier = -1;
  for (var lwl = lotwLevels.length - 1; lwl >= 0; lwl--) { if (lotwQsos >= lotwLevels[lwl]) { lotwTier = lwl; break; } }
  result.push({
    id: "lotwConfirmed", icon: "\u2705", cat: "award",
    tier: lotwTier, tierName: lotwTier >= 0 ? TIER_NAMES[Math.min(lotwTier, TIER_NAMES.length - 1)] : null,
    tierColor: lotwTier >= 0 ? TIER_COLORS[Math.min(lotwTier, TIER_COLORS.length - 1)] : "#334155",
    value: lotwQsos, threshold: lotwTier >= 0 ? lotwLevels[lotwTier] : lotwLevels[0],
    nextLevel: lotwTier < lotwLevels.length - 1 ? lotwLevels[lotwTier + 1] : null,
    progress: lotwTier < lotwLevels.length - 1 ? Math.min(1, lotwQsos / lotwLevels[lotwTier + 1]) : 1, unlocked: lotwTier >= 0
  });

  // Marathon - unique operating days
  var opDays = {};
  for (var oi = 0; oi < qsos.length; oi++) { var od = qsos[oi].date; if (od && od.length === 8) opDays[od] = 1; }
  var opDayCount = Object.keys(opDays).length;
  var marLevels = [10, 30, 90, 180, 365];
  var marTier = -1;
  for (var mli = marLevels.length - 1; mli >= 0; mli--) { if (opDayCount >= marLevels[mli]) { marTier = mli; break; } }
  result.push({
    id: "marathon", icon: "\u{1F3C3}", cat: "time",
    tier: marTier, tierName: marTier >= 0 ? TIER_NAMES[Math.min(marTier, TIER_NAMES.length - 1)] : null,
    tierColor: marTier >= 0 ? TIER_COLORS[Math.min(marTier, TIER_COLORS.length - 1)] : "#334155",
    value: opDayCount, threshold: marTier >= 0 ? marLevels[marTier] : marLevels[0],
    nextLevel: marTier < marLevels.length - 1 ? marLevels[marTier + 1] : null,
    progress: marTier < marLevels.length - 1 ? Math.min(1, opDayCount / marLevels[marTier + 1]) : 1, unlocked: marTier >= 0
  });

  // QRZ Confirmed QSOs (comment === "QRZ-C")
  var qrzQsos = 0;
  for (var qzi = 0; qzi < qsos.length; qzi++) { if (qsos[qzi].qrzQsl || qsos[qzi].comment === "QRZ-C") qrzQsos++; }
  var qrzLevels = [10, 100, 500, 1000, 5000, 10000];
  var qrzTier = -1;
  for (var qzl = qrzLevels.length - 1; qzl >= 0; qzl--) { if (qrzQsos >= qrzLevels[qzl]) { qrzTier = qzl; break; } }
  result.push({
    id: "qrzConfirmed", icon: "\u{1F4C7}", cat: "award",
    tier: qrzTier, tierName: qrzTier >= 0 ? TIER_NAMES[Math.min(qrzTier, TIER_NAMES.length - 1)] : null,
    tierColor: qrzTier >= 0 ? TIER_COLORS[Math.min(qrzTier, TIER_COLORS.length - 1)] : "#334155",
    value: qrzQsos, threshold: qrzTier >= 0 ? qrzLevels[qrzTier] : qrzLevels[0],
    nextLevel: qrzTier < qrzLevels.length - 1 ? qrzLevels[qrzTier + 1] : null,
    progress: qrzTier < qrzLevels.length - 1 ? Math.min(1, qrzQsos / qrzLevels[qrzTier + 1]) : 1, unlocked: qrzTier >= 0
  });

  return result;
}

// Badge label translations
export var BADGE_LABELS = {
  pt: {
    qso100: "QSOs", dxcc: "DX Hunter", grids: "Grid Master", calls: "Calls \u00danicos",
    wac: "Todos Continentes", bands: "Explorador de Bandas", modes: "Mestre dos Modos",
    digital: "Pioneiro Digital", cw: "Guerreiro CW", lotwConfirmed: "Confirmados LoTW",
    marathon: "Maratonista", qrzConfirmed: "Confirmados QRZ",
    badgesTitle: "Conquistas", badgesUnlocked: "desbloqueadas",
    bronze: "Bronze", silver: "Prata", gold: "Ouro", platinum: "Platina", diamond: "Diamante", master: "Mestre", legend: "Lenda"
  },
  en: {
    qso100: "QSOs", dxcc: "DX Hunter", grids: "Grid Master", calls: "Unique Calls",
    wac: "All Continents", bands: "Band Explorer", modes: "Mode Master",
    digital: "Digital Pioneer", cw: "CW Warrior", lotwConfirmed: "LoTW Confirmed",
    marathon: "Marathon", qrzConfirmed: "QRZ Confirmed",
    badgesTitle: "Achievements", badgesUnlocked: "unlocked",
    bronze: "Bronze", silver: "Silver", gold: "Gold", platinum: "Platinum", diamond: "Diamond", master: "Master", legend: "Legend"
  }
};
